import * as React from 'react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import SaveIcon from '@mui/icons-material/Save'
import UploadForm from './UploadForm'
import { useAuth } from '../../auth/AuthContext'

UploadDialog.propTypes = {
  upload: PropTypes.object,
  isOpen: PropTypes.bool,
  onSave: PropTypes.func,
  onCancel: PropTypes.func
}
export default function UploadDialog (props) {
  const { isOpen, onSave, onCancel } = props
  const [open, setOpen] = useState(isOpen)
  const { groups } = useAuth()
  const [upload, setUpload] = useState(props.upload)

  const handleSave = (ev) => {
    if (onSave) {
      onSave(ev, upload)
    }
    setOpen(false)
  }

  const handleCancel = (ev, reason) => {
    if (reason === 'backdropClick') {
      return
    } else if (onCancel) {
      onCancel(ev, upload)
    }
    setOpen(false)
  }

  const onNameChange = (ev) => {
    setUpload(Object.assign({}, upload, { name: ev.target.value }))
  }

  const onDescriptionChange = (ev) => {
    setUpload(Object.assign({}, upload, { description: ev.target.value }))
  }

  const onDateChange = date => {
    setUpload(Object.assign({}, upload, { date }))
  }

  const onGroupChange = values => {
    const allowed = values.filter(group => groups.includes(group) || (props.upload.groups || []).includes(group))
    setUpload(current => ({ ...current, groups: allowed }))
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCancel}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle>{upload ? upload.name : ''}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter or update the details for the upload and click save.
          </DialogContentText>
          <UploadForm
            groups={groups}
            upload={upload}
            onNameChange={onNameChange}
            onDescriptionChange={onDescriptionChange}
            onDateChange={onDateChange}
            onGroupChange={onGroupChange}
          />
        </DialogContent>
        <DialogActions sx={{ marginBottom: '1em', marginRight: '1em' }}>
          <Button color="secondary" variant="outlined" onClick={handleCancel}>
            <CancelIcon fontSize="x-small"/>&nbsp;Cancel
          </Button>
          <Button color="primary" variant="contained" onClick={handleSave}>
            <SaveIcon fontSize="x-small"/>&nbsp;Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
